// A escolha do relatório especial (pedido do Ilton, 30/09 e 01/10).
//
// Primeiro foi uma fila de botões (poluída); depois um botão com uma setinha que
// abria um menu — e o Ilton não achou o relatório da conversa de 01/10: a
// setinha não dizia que havia uma lista ali, nem onde estava o novo. Agora os
// grupos ficam SEMPRE à vista, cada um com quantos documentos tem; tocar no
// grupo abre os títulos dele (inteiros, quebrando linha). O que foi feito ou
// atualizado nas últimas 24 h ganha a marca NOVO, e o grupo que tem novidade
// diz isso antes de abrir. O "não entregar" vem marcado, para não ir parar na
// mão da equipe por engano. Desenho puro: a tela busca.
import { useState } from 'react';
import { diaDoInstante, formatarData } from '@medicov1/shared';
import { agruparEspeciais, grupoDoEspecial, GRUPOS_ESPECIAIS, type GrupoEspecial, type ResumoEspecialDTO } from './relatorioEspecialTipos';

interface Props {
  especiais: ResumoEspecialDTO[];
  especialId: string | null;
  aoEscolher: (id: string) => void;
  /** Só para a prova visual: grupos já abertos e o "agora" fixo. */
  abertosIniciais?: GrupoEspecial[];
  agora?: number;
}

const data = (iso: string) => formatarData(diaDoInstante(iso));
const DIA_MS = 24 * 60 * 60 * 1000;

export function EscolhaDoEspecial({ especiais, especialId, aoEscolher, abertosIniciais = [], agora = Date.now() }: Props) {
  const [abertos, setAbertos] = useState<Set<GrupoEspecial>>(() => new Set(abertosIniciais));
  const atual = especiais.find((x) => x.id === especialId);
  const grupoAtual = atual ? GRUPOS_ESPECIAIS.find((g) => g.chave === grupoDoEspecial(atual)) : undefined;
  const novo = (e: ResumoEspecialDTO) => agora - new Date(e.geradoEm).getTime() < DIA_MS;
  const alternar = (g: GrupoEspecial) => setAbertos((s) => {
    const n = new Set(s);
    if (n.has(g)) n.delete(g); else n.add(g);
    return n;
  });

  return (
    <div className="esp-escolha">
      {atual && grupoAtual && (
        <div className={`esp-escolha__aberto esp-escolha__aberto--${grupoAtual.chave}`}>
          <span className="rel__rotulo">Aberto agora</span>
          <b>{atual.titulo}</b>
          <small>{grupoAtual.rotulo} · {data(atual.geradoEm)}</small>
        </div>
      )}

      <span className="rel__rotulo">Escolha o relatório — toque no grupo para ver os títulos</span>
      <div className="esp-escolha__grupos">
        {agruparEspeciais(especiais).map(({ grupo, itens }) => {
          const aberto = abertos.has(grupo.chave);
          const novos = itens.filter(novo).length;
          return (
            <section key={grupo.chave} className={`esp-escolha__grupo esp-escolha__grupo--${grupo.chave}`}>
              <button type="button" className="esp-escolha__cabeca" aria-expanded={aberto} onClick={() => alternar(grupo.chave)}>
                <span className="esp-escolha__seta" aria-hidden="true">{aberto ? '▾' : '▸'}</span>
                <span className="esp-escolha__nome">
                  <b>{grupo.rotulo} ({itens.length})</b>
                  <small>{grupo.descricao}</small>
                </span>
                {novos > 0 && <span className="esp-escolha__novo">{novos === 1 ? 'NOVO' : `${novos} NOVOS`}</span>}
              </button>
              {aberto && (
                <div className="esp-escolha__itens">
                  {itens.map((x) => (
                    <button key={x.id} type="button"
                      className={`esp-escolha__item${x.id === especialId ? ' esp-escolha__item--on' : ''}`}
                      onClick={() => aoEscolher(x.id)}>
                      <span className="esp-escolha__item-titulo">{x.titulo}</span>
                      <span className="esp-escolha__item-data">
                        {data(x.geradoEm)}
                        {novo(x) && <span className="esp-escolha__novo">NOVO</span>}
                        {x.id === especialId && <span className="esp-escolha__marca">aberto</span>}
                      </span>
                    </button>
                  ))}
                </div>
              )}
            </section>
          );
        })}
      </div>
    </div>
  );
}
